import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "relative isolate overflow-hidden text-white px-3 pb-24 sm:pt-16 sm:pb-32 lg:overflow-visible lg:px-0" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("div", { class: "flex justify-center mb-5" }, [
      _createElementVNode("a", { href: "/" }, [
        _createElementVNode("img", {
          src: "/images/logo.webp",
          alt: "Links Digest",
          class1: "h-10 w-10"
        })
      ])
    ], -1),
    _createElementVNode("div", { class: "mx-auto grid max-w-2xl gap-y-16 lg:mx-0 lg:max-w-none 1 lg:items-start lg:gap-y-10" }, [
      _createElementVNode("div", { class: "lg:col-span-2 lg:col-start-1 lg:row-start-1 lg:mx-auto lg:grid lg:w-full lg:max-w-7xl lg:gap-x-8 lg:px-8" }, [
        _createElementVNode("div", { class: "lg:pr-4" }, [
          _createElementVNode("div", null, [
            _createElementVNode("p", { class: "text-base/7 font-semibold text-cyan-400" }, "Links Digest"),
            _createElementVNode("h1", { class: "mt-2 text-4xl font-semibold tracking-tight text-pretty sm:text-5xl" }, "Terms & Conditions"),
            _createElementVNode("p", { class: "mt-2" }, [
              _createElementVNode("strong", null, "Last updated:"),
              _createTextVNode(" January 26th, 2026")
            ]),
            _createElementVNode("p", { class: "mt-6 text-xl/8" }, [
              _createTextVNode(" Welcome to "),
              _createElementVNode("strong", null, "linksdigest.com"),
              _createTextVNode(" (\"Website\"), owned and operated by "),
              _createElementVNode("strong", null, "Lazuli Labs, Lda"),
              _createTextVNode(" (\"we\", \"our\", \"us\"). By accessing or using this Website, you agree to be bound by these Terms & Conditions. If you do not agree with any part of these terms, please do not use the Website. ")
            ])
          ])
        ])
      ]),
      _createElementVNode("div", { class: "lg:col-span-2 lg:col-start-1 lg:mx-auto lg:w-full lg:max-w-7xl lg:px-8" }, [
        _createElementVNode("div", { class: "lg:pr-4" }, [
          _createElementVNode("div", { class: "text-base/7" }, [
            _createElementVNode("ul", {
              role: "list",
              class: "mt-8 space-y-8"
            }, [
              _createElementVNode("li", { class: "flex gap-x-3" }, [
                _createElementVNode("svg", {
                  xmlns: "http://www.w3.org/2000/svg",
                  fill: "none",
                  viewBox: "0 0 24 24",
                  "stroke-width": "1.3",
                  stroke: "currentColor",
                  class: "size-6 text-cyan-400"
                }, [
                  _createElementVNode("path", {
                    "stroke-linecap": "round",
                    "stroke-linejoin": "round",
                    d: "M12 21a9.004 9.004 0 0 0 8.716-6.747M12 21a9.004 9.004 0 0 1-8.716-6.747M12 21c2.485 0 4.5-4.03 4.5-9S14.485 3 12 3m0 18c-2.485 0-4.5-4.03-4.5-9S9.515 3 12 3m0 0a8.997 8.997 0 0 1 7.843 4.582M12 3a8.997 8.997 0 0 0-7.843 4.582m15.686 0A11.953 11.953 0 0 1 12 10.5c-2.998 0-5.74-1.1-7.843-2.918m15.686 0A8.959 8.959 0 0 1 21 12c0 .778-.099 1.533-.284 2.253m0 0A17.919 17.919 0 0 1 12 16.5c-3.162 0-6.133-.815-8.716-2.247m0 0A9.015 9.015 0 0 1 3 12c0-1.605.42-3.113 1.157-4.418"
                  })
                ]),
                _createElementVNode("h2", null, "1. About Links Digest")
              ]),
              _createElementVNode("p", { class: "ms-4" }, [
                _createElementVNode("strong", { class: "font-semibold" }, "Links Digest"),
                _createTextVNode(" is a link curation platform that combines original content created by us with links to third-party websites. The purpose of the Website is to help users discover, explore, and share useful content available on the internet. ")
              ]),
              _createElementVNode("hr"),
              _createElementVNode("li", { class: "flex gap-x-3" }, [
                _createElementVNode("svg", {
                  xmlns: "http://www.w3.org/2000/svg",
                  fill: "none",
                  viewBox: "0 0 24 24",
                  "stroke-width": "1.3",
                  stroke: "currentColor",
                  class: "size-6 text-cyan-400"
                }, [
                  _createElementVNode("path", {
                    "stroke-linecap": "round",
                    "stroke-linejoin": "round",
                    d: "M12 21a9.004 9.004 0 0 0 8.716-6.747M12 21a9.004 9.004 0 0 1-8.716-6.747M12 21c2.485 0 4.5-4.03 4.5-9S14.485 3 12 3m0 18c-2.485 0-4.5-4.03-4.5-9S9.515 3 12 3m0 0a8.997 8.997 0 0 1 7.843 4.582M12 3a8.997 8.997 0 0 0-7.843 4.582m15.686 0A11.953 11.953 0 0 1 12 10.5c-2.998 0-5.74-1.1-7.843-2.918m15.686 0A8.959 8.959 0 0 1 21 12c0 .778-.099 1.533-.284 2.253m0 0A17.919 17.919 0 0 1 12 16.5c-3.162 0-6.133-.815-8.716-2.247m0 0A9.015 9.015 0 0 1 3 12c0-1.605.42-3.113 1.157-4.418"
                  })
                ]),
                _createElementVNode("h2", null, "2. User Submissions")
              ]),
              _createElementVNode("p", { class: "ms-4" }, " Users may submit links for inclusion on the Website. All submitted links are subject to review and approval before being published. "),
              _createElementVNode("p", { class: "ms-4" }, "We reserve the right, at our sole discretion, to:"),
              _createElementVNode("ul", { class: "ms-8" }, [
                _createElementVNode("li", { class: "flex gap-x-3" }, [
                  _createElementVNode("svg", {
                    viewBox: "0 0 20 20",
                    fill: "currentColor",
                    "data-slot": "icon",
                    "aria-hidden": "true",
                    class: "mt-1 size-5 flex-none text-cyan-400"
                  }, [
                    _createElementVNode("path", {
                      d: "M10 1a4.5 4.5 0 0 0-4.5 4.5V9H5a2 2 0 0 0-2 2v6a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2v-6a2 2 0 0 0-2-2h-.5V5.5A4.5 4.5 0 0 0 10 1Zm3 8V5.5a3 3 0 1 0-6 0V9h6Z",
                      "clip-rule": "evenodd",
                      "fill-rule": "evenodd"
                    })
                  ]),
                  _createTextVNode(" Approve or reject any submitted link ")
                ]),
                _createElementVNode("li", { class: "flex gap-x-3" }, [
                  _createElementVNode("svg", {
                    viewBox: "0 0 20 20",
                    fill: "currentColor",
                    "data-slot": "icon",
                    "aria-hidden": "true",
                    class: "mt-1 size-5 flex-none text-cyan-400"
                  }, [
                    _createElementVNode("path", {
                      d: "M10 1a4.5 4.5 0 0 0-4.5 4.5V9H5a2 2 0 0 0-2 2v6a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2v-6a2 2 0 0 0-2-2h-.5V5.5A4.5 4.5 0 0 0 10 1Zm3 8V5.5a3 3 0 1 0-6 0V9h6Z",
                      "clip-rule": "evenodd",
                      "fill-rule": "evenodd"
                    })
                  ]),
                  _createTextVNode(" Edit, categorize, or display submitted links as we see fit ")
                ]),
                _createElementVNode("li", { class: "flex gap-x-3" }, [
                  _createElementVNode("svg", {
                    viewBox: "0 0 20 20",
                    fill: "currentColor",
                    "data-slot": "icon",
                    "aria-hidden": "true",
                    class: "mt-1 size-5 flex-none text-cyan-400"
                  }, [
                    _createElementVNode("path", {
                      d: "M10 1a4.5 4.5 0 0 0-4.5 4.5V9H5a2 2 0 0 0-2 2v6a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2v-6a2 2 0 0 0-2-2h-.5V5.5A4.5 4.5 0 0 0 10 1Zm3 8V5.5a3 3 0 1 0-6 0V9h6Z",
                      "clip-rule": "evenodd",
                      "fill-rule": "evenodd"
                    })
                  ]),
                  _createTextVNode(" Remove any link at any time, without prior notice ")
                ])
              ]),
              _createElementVNode("p", { class: "ms-4" }, "Submitting a link does not guarantee its publication."),
              _createElementVNode("hr"),
              _createElementVNode("li", { class: "flex gap-x-3" }, [
                _createElementVNode("svg", {
                  xmlns: "http://www.w3.org/2000/svg",
                  fill: "none",
                  viewBox: "0 0 24 24",
                  "stroke-width": "1.3",
                  stroke: "currentColor",
                  class: "size-6 text-cyan-400"
                }, [
                  _createElementVNode("path", {
                    "stroke-linecap": "round",
                    "stroke-linejoin": "round",
                    d: "M12 21a9.004 9.004 0 0 0 8.716-6.747M12 21a9.004 9.004 0 0 1-8.716-6.747M12 21c2.485 0 4.5-4.03 4.5-9S14.485 3 12 3m0 18c-2.485 0-4.5-4.03-4.5-9S9.515 3 12 3m0 0a8.997 8.997 0 0 1 7.843 4.582M12 3a8.997 8.997 0 0 0-7.843 4.582m15.686 0A11.953 11.953 0 0 1 12 10.5c-2.998 0-5.74-1.1-7.843-2.918m15.686 0A8.959 8.959 0 0 1 21 12c0 .778-.099 1.533-.284 2.253m0 0A17.919 17.919 0 0 1 12 16.5c-3.162 0-6.133-.815-8.716-2.247m0 0A9.015 9.015 0 0 1 3 12c0-1.605.42-3.113 1.157-4.418"
                  })
                ]),
                _createElementVNode("span", null, [
                  _createElementVNode("h2", null, "3. External Links Disclaimer")
                ])
              ]),
              _createElementVNode("p", { class: "ms-4" }, " Links digest contains links to external websites that are not owned, operated, or controlled by us. "),
              _createElementVNode("ul", { class: "ms-8" }, [
                _createElementVNode("li", { class: "flex gap-x-3" }, [
                  _createElementVNode("svg", {
                    viewBox: "0 0 20 20",
                    fill: "currentColor",
                    "data-slot": "icon",
                    "aria-hidden": "true",
                    class: "mt-1 size-5 flex-none text-cyan-400"
                  }, [
                    _createElementVNode("path", {
                      d: "M10 1a4.5 4.5 0 0 0-4.5 4.5V9H5a2 2 0 0 0-2 2v6a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2v-6a2 2 0 0 0-2-2h-.5V5.5A4.5 4.5 0 0 0 10 1Zm3 8V5.5a3 3 0 1 0-6 0V9h6Z",
                      "clip-rule": "evenodd",
                      "fill-rule": "evenodd"
                    })
                  ]),
                  _createTextVNode(" We do not guarantee the accuracy, relevance, or quality of any external content ")
                ]),
                _createElementVNode("li", { class: "flex gap-x-3" }, [
                  _createElementVNode("svg", {
                    viewBox: "0 0 20 20",
                    fill: "currentColor",
                    "data-slot": "icon",
                    "aria-hidden": "true",
                    class: "mt-1 size-5 flex-none text-cyan-400"
                  }, [
                    _createElementVNode("path", {
                      d: "M10 1a4.5 4.5 0 0 0-4.5 4.5V9H5a2 2 0 0 0-2 2v6a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2v-6a2 2 0 0 0-2-2h-.5V5.5A4.5 4.5 0 0 0 10 1Zm3 8V5.5a3 3 0 1 0-6 0V9h6Z",
                      "clip-rule": "evenodd",
                      "fill-rule": "evenodd"
                    })
                  ]),
                  _createTextVNode(" We are not responsible for the content, policies, or practices of third-party websites ")
                ]),
                _createElementVNode("li", { class: "flex gap-x-3" }, [
                  _createElementVNode("svg", {
                    viewBox: "0 0 20 20",
                    fill: "currentColor",
                    "data-slot": "icon",
                    "aria-hidden": "true",
                    class: "mt-1 size-5 flex-none text-cyan-400"
                  }, [
                    _createElementVNode("path", {
                      d: "M10 1a4.5 4.5 0 0 0-4.5 4.5V9H5a2 2 0 0 0-2 2v6a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2v-6a2 2 0 0 0-2-2h-.5V5.5A4.5 4.5 0 0 0 10 1Zm3 8V5.5a3 3 0 1 0-6 0V9h6Z",
                      "clip-rule": "evenodd",
                      "fill-rule": "evenodd"
                    })
                  ]),
                  _createTextVNode(" We do not endorse any external website, product, or service unless explicitly stated ")
                ])
              ]),
              _createElementVNode("p", { class: "ms-4" }, "Accessing external links is done at your own risk."),
              _createElementVNode("hr"),
              _createElementVNode("li", { class: "flex gap-x-3" }, [
                _createElementVNode("svg", {
                  xmlns: "http://www.w3.org/2000/svg",
                  fill: "none",
                  viewBox: "0 0 24 24",
                  "stroke-width": "1.3",
                  stroke: "currentColor",
                  class: "size-6 text-cyan-400"
                }, [
                  _createElementVNode("path", {
                    "stroke-linecap": "round",
                    "stroke-linejoin": "round",
                    d: "M12 21a9.004 9.004 0 0 0 8.716-6.747M12 21a9.004 9.004 0 0 1-8.716-6.747M12 21c2.485 0 4.5-4.03 4.5-9S14.485 3 12 3m0 18c-2.485 0-4.5-4.03-4.5-9S9.515 3 12 3m0 0a8.997 8.997 0 0 1 7.843 4.582M12 3a8.997 8.997 0 0 0-7.843 4.582m15.686 0A11.953 11.953 0 0 1 12 10.5c-2.998 0-5.74-1.1-7.843-2.918m15.686 0A8.959 8.959 0 0 1 21 12c0 .778-.099 1.533-.284 2.253m0 0A17.919 17.919 0 0 1 12 16.5c-3.162 0-6.133-.815-8.716-2.247m0 0A9.015 9.015 0 0 1 3 12c0-1.605.42-3.113 1.157-4.418"
                  })
                ]),
                _createElementVNode("h2", null, "4. Removal Requests")
              ]),
              _createElementVNode("p", { class: "ms-4" }, " We accept requests for link removal, including but not limited to copyright or intellectual property concerns, legal issues, and outdated or misleading content. "),
              _createElementVNode("p", { class: "ms-4" }, [
                _createTextVNode(" Removal requests should be sent to "),
                _createElementVNode("a", {
                  href: "mailto:linksdigest@lazulilabs.com",
                  class: "text-white hover:text-cyan-400"
                }, "linksdigest@lazulilabs.com"),
                _createTextVNode(". We will review each request and act at our discretion. ")
              ]),
              _createElementVNode("hr"),
              _createElementVNode("li", { class: "flex gap-x-3" }, [
                _createElementVNode("svg", {
                  xmlns: "http://www.w3.org/2000/svg",
                  fill: "none",
                  viewBox: "0 0 24 24",
                  "stroke-width": "1.3",
                  stroke: "currentColor",
                  class: "size-6 text-cyan-400"
                }, [
                  _createElementVNode("path", {
                    "stroke-linecap": "round",
                    "stroke-linejoin": "round",
                    d: "M12 21a9.004 9.004 0 0 0 8.716-6.747M12 21a9.004 9.004 0 0 1-8.716-6.747M12 21c2.485 0 4.5-4.03 4.5-9S14.485 3 12 3m0 18c-2.485 0-4.5-4.03-4.5-9S9.515 3 12 3m0 0a8.997 8.997 0 0 1 7.843 4.582M12 3a8.997 8.997 0 0 0-7.843 4.582m15.686 0A11.953 11.953 0 0 1 12 10.5c-2.998 0-5.74-1.1-7.843-2.918m15.686 0A8.959 8.959 0 0 1 21 12c0 .778-.099 1.533-.284 2.253m0 0A17.919 17.919 0 0 1 12 16.5c-3.162 0-6.133-.815-8.716-2.247m0 0A9.015 9.015 0 0 1 3 12c0-1.605.42-3.113 1.157-4.418"
                  })
                ]),
                _createElementVNode("h2", null, "5. User Accounts")
              ]),
              _createElementVNode("p", { class: "ms-4" }, " Links digest offers user accounts to enable participation features such as submitting links or managing preferences. "),
              _createElementVNode("p", { class: "ms-4" }, " By creating an account, you agree that: "),
              _createElementVNode("ul", { class: "ms-8" }, [
                _createElementVNode("li", { class: "flex gap-x-3" }, [
                  _createElementVNode("svg", {
                    viewBox: "0 0 20 20",
                    fill: "currentColor",
                    "data-slot": "icon",
                    "aria-hidden": "true",
                    class: "mt-1 size-5 flex-none text-cyan-400"
                  }, [
                    _createElementVNode("path", {
                      d: "M10 1a4.5 4.5 0 0 0-4.5 4.5V9H5a2 2 0 0 0-2 2v6a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2v-6a2 2 0 0 0-2-2h-.5V5.5A4.5 4.5 0 0 0 10 1Zm3 8V5.5a3 3 0 1 0-6 0V9h6Z",
                      "clip-rule": "evenodd",
                      "fill-rule": "evenodd"
                    })
                  ]),
                  _createTextVNode(" You will provide accurate and up-to-date information ")
                ]),
                _createElementVNode("li", { class: "flex gap-x-3" }, [
                  _createElementVNode("svg", {
                    viewBox: "0 0 20 20",
                    fill: "currentColor",
                    "data-slot": "icon",
                    "aria-hidden": "true",
                    class: "mt-1 size-5 flex-none text-cyan-400"
                  }, [
                    _createElementVNode("path", {
                      d: "M10 1a4.5 4.5 0 0 0-4.5 4.5V9H5a2 2 0 0 0-2 2v6a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2v-6a2 2 0 0 0-2-2h-.5V5.5A4.5 4.5 0 0 0 10 1Zm3 8V5.5a3 3 0 1 0-6 0V9h6Z",
                      "clip-rule": "evenodd",
                      "fill-rule": "evenodd"
                    })
                  ]),
                  _createTextVNode(" You are responsible for maintaining the confidentiality of your account ")
                ]),
                _createElementVNode("li", { class: "flex gap-x-3" }, [
                  _createElementVNode("svg", {
                    viewBox: "0 0 20 20",
                    fill: "currentColor",
                    "data-slot": "icon",
                    "aria-hidden": "true",
                    class: "mt-1 size-5 flex-none text-cyan-400"
                  }, [
                    _createElementVNode("path", {
                      d: "M10 1a4.5 4.5 0 0 0-4.5 4.5V9H5a2 2 0 0 0-2 2v6a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2v-6a2 2 0 0 0-2-2h-.5V5.5A4.5 4.5 0 0 0 10 1Zm3 8V5.5a3 3 0 1 0-6 0V9h6Z",
                      "clip-rule": "evenodd",
                      "fill-rule": "evenodd"
                    })
                  ]),
                  _createTextVNode(" You are responsible for all activity that occurs under your account ")
                ])
              ]),
              _createElementVNode("p", { class: "ms-4" }, " We reserve the right to suspend or terminate accounts that violate these Terms or misuse the platform. "),
              _createElementVNode("hr"),
              _createElementVNode("li", { class: "flex gap-x-3" }, [
                _createElementVNode("svg", {
                  xmlns: "http://www.w3.org/2000/svg",
                  fill: "none",
                  viewBox: "0 0 24 24",
                  "stroke-width": "1.3",
                  stroke: "currentColor",
                  class: "size-6 text-cyan-400"
                }, [
                  _createElementVNode("path", {
                    "stroke-linecap": "round",
                    "stroke-linejoin": "round",
                    d: "M12 21a9.004 9.004 0 0 0 8.716-6.747M12 21a9.004 9.004 0 0 1-8.716-6.747M12 21c2.485 0 4.5-4.03 4.5-9S14.485 3 12 3m0 18c-2.485 0-4.5-4.03-4.5-9S9.515 3 12 3m0 0a8.997 8.997 0 0 1 7.843 4.582M12 3a8.997 8.997 0 0 0-7.843 4.582m15.686 0A11.953 11.953 0 0 1 12 10.5c-2.998 0-5.74-1.1-7.843-2.918m15.686 0A8.959 8.959 0 0 1 21 12c0 .778-.099 1.533-.284 2.253m0 0A17.919 17.919 0 0 1 12 16.5c-3.162 0-6.133-.815-8.716-2.247m0 0A9.015 9.015 0 0 1 3 12c0-1.605.42-3.113 1.157-4.418"
                  })
                ]),
                _createElementVNode("h2", null, "6. Advertising")
              ]),
              _createElementVNode("p", { class: "ms-4" }, " The Website may display advertising, sponsored content, or promotional links. "),
              _createElementVNode("p", { class: "ms-4" }, " We are not responsible for the content of advertisements, the products or services offered by advertisers, or any interaction between users and advertisers. "),
              _createElementVNode("hr"),
              _createElementVNode("li", { class: "flex gap-x-3" }, [
                _createElementVNode("svg", {
                  xmlns: "http://www.w3.org/2000/svg",
                  fill: "none",
                  viewBox: "0 0 24 24",
                  "stroke-width": "1.3",
                  stroke: "currentColor",
                  class: "size-6 text-cyan-400"
                }, [
                  _createElementVNode("path", {
                    "stroke-linecap": "round",
                    "stroke-linejoin": "round",
                    d: "M12 21a9.004 9.004 0 0 0 8.716-6.747M12 21a9.004 9.004 0 0 1-8.716-6.747M12 21c2.485 0 4.5-4.03 4.5-9S14.485 3 12 3m0 18c-2.485 0-4.5-4.03-4.5-9S9.515 3 12 3m0 0a8.997 8.997 0 0 1 7.843 4.582M12 3a8.997 8.997 0 0 0-7.843 4.582m15.686 0A11.953 11.953 0 0 1 12 10.5c-2.998 0-5.74-1.1-7.843-2.918m15.686 0A8.959 8.959 0 0 1 21 12c0 .778-.099 1.533-.284 2.253m0 0A17.919 17.919 0 0 1 12 16.5c-3.162 0-6.133-.815-8.716-2.247m0 0A9.015 9.015 0 0 1 3 12c0-1.605.42-3.113 1.157-4.418"
                  })
                ]),
                _createElementVNode("h2", null, "7. Intellectual Property")
              ]),
              _createElementVNode("p", { class: "ms-4" }, [
                _createTextVNode(" All original content on Links Digest, including text, branding, design, and logos, is the property of "),
                _createElementVNode("strong", null, "Lazuli Labs, Lda"),
                _createTextVNode(", unless otherwise stated. ")
              ]),
              _createElementVNode("p", { class: "ms-4" }, " You may not reproduce, distribute, or reuse our content without prior written permission. "),
              _createElementVNode("hr"),
              _createElementVNode("li", { class: "flex gap-x-3" }, [
                _createElementVNode("svg", {
                  xmlns: "http://www.w3.org/2000/svg",
                  fill: "none",
                  viewBox: "0 0 24 24",
                  "stroke-width": "1.3",
                  stroke: "currentColor",
                  class: "size-6 text-cyan-400"
                }, [
                  _createElementVNode("path", {
                    "stroke-linecap": "round",
                    "stroke-linejoin": "round",
                    d: "M12 21a9.004 9.004 0 0 0 8.716-6.747M12 21a9.004 9.004 0 0 1-8.716-6.747M12 21c2.485 0 4.5-4.03 4.5-9S14.485 3 12 3m0 18c-2.485 0-4.5-4.03-4.5-9S9.515 3 12 3m0 0a8.997 8.997 0 0 1 7.843 4.582M12 3a8.997 8.997 0 0 0-7.843 4.582m15.686 0A11.953 11.953 0 0 1 12 10.5c-2.998 0-5.74-1.1-7.843-2.918m15.686 0A8.959 8.959 0 0 1 21 12c0 .778-.099 1.533-.284 2.253m0 0A17.919 17.919 0 0 1 12 16.5c-3.162 0-6.133-.815-8.716-2.247m0 0A9.015 9.015 0 0 1 3 12c0-1.605.42-3.113 1.157-4.418"
                  })
                ]),
                _createElementVNode("h2", null, "8. Limitation of Liability")
              ]),
              _createElementVNode("p", { class: "ms-4" }, " To the maximum extent permitted by law, Lazuli Labs, Lda shall not be liable for any direct or indirect damages resulting from the use of the Website, inability to access the Website, or reliance on external links or third-party content. "),
              _createElementVNode("p", { class: "ms-4" }, " The Website is provided on an \"as is\" and \"as available\" basis. "),
              _createElementVNode("hr"),
              _createElementVNode("li", { class: "flex gap-x-3" }, [
                _createElementVNode("svg", {
                  xmlns: "http://www.w3.org/2000/svg",
                  fill: "none",
                  viewBox: "0 0 24 24",
                  "stroke-width": "1.3",
                  stroke: "currentColor",
                  class: "size-6 text-cyan-400"
                }, [
                  _createElementVNode("path", {
                    "stroke-linecap": "round",
                    "stroke-linejoin": "round",
                    d: "M12 21a9.004 9.004 0 0 0 8.716-6.747M12 21a9.004 9.004 0 0 1-8.716-6.747M12 21c2.485 0 4.5-4.03 4.5-9S14.485 3 12 3m0 18c-2.485 0-4.5-4.03-4.5-9S9.515 3 12 3m0 0a8.997 8.997 0 0 1 7.843 4.582M12 3a8.997 8.997 0 0 0-7.843 4.582m15.686 0A11.953 11.953 0 0 1 12 10.5c-2.998 0-5.74-1.1-7.843-2.918m15.686 0A8.959 8.959 0 0 1 21 12c0 .778-.099 1.533-.284 2.253m0 0A17.919 17.919 0 0 1 12 16.5c-3.162 0-6.133-.815-8.716-2.247m0 0A9.015 9.015 0 0 1 3 12c0-1.605.42-3.113 1.157-4.418"
                  })
                ]),
                _createElementVNode("h2", null, "9. Governing Law")
              ]),
              _createElementVNode("p", { class: "ms-4" }, " These Terms & Conditions are governed by and construed in accordance with the laws of Portugal and the European Union. "),
              _createElementVNode("p", { class: "ms-4" }, " Any disputes arising from these Terms shall be subject to the exclusive jurisdiction of the competent courts. "),
              _createElementVNode("hr"),
              _createElementVNode("li", { class: "flex gap-x-3" }, [
                _createElementVNode("svg", {
                  xmlns: "http://www.w3.org/2000/svg",
                  fill: "none",
                  viewBox: "0 0 24 24",
                  "stroke-width": "1.3",
                  stroke: "currentColor",
                  class: "size-6 text-cyan-400"
                }, [
                  _createElementVNode("path", {
                    "stroke-linecap": "round",
                    "stroke-linejoin": "round",
                    d: "M12 21a9.004 9.004 0 0 0 8.716-6.747M12 21a9.004 9.004 0 0 1-8.716-6.747M12 21c2.485 0 4.5-4.03 4.5-9S14.485 3 12 3m0 18c-2.485 0-4.5-4.03-4.5-9S9.515 3 12 3m0 0a8.997 8.997 0 0 1 7.843 4.582M12 3a8.997 8.997 0 0 0-7.843 4.582m15.686 0A11.953 11.953 0 0 1 12 10.5c-2.998 0-5.74-1.1-7.843-2.918m15.686 0A8.959 8.959 0 0 1 21 12c0 .778-.099 1.533-.284 2.253m0 0A17.919 17.919 0 0 1 12 16.5c-3.162 0-6.133-.815-8.716-2.247m0 0A9.015 9.015 0 0 1 3 12c0-1.605.42-3.113 1.157-4.418"
                  })
                ]),
                _createElementVNode("h2", null, "10. Changes to These Terms")
              ]),
              _createElementVNode("p", { class: "ms-4" }, " We reserve the right to update or modify these Terms & Conditions at any time. Changes will be effective upon publication on this page. "),
              _createElementVNode("p", { class: "ms-4" }, " Continued use of the Website after changes constitutes acceptance of the updated Terms. "),
              _createElementVNode("hr"),
              _createElementVNode("li", { class: "flex gap-x-3" }, [
                _createElementVNode("svg", {
                  xmlns: "http://www.w3.org/2000/svg",
                  fill: "none",
                  viewBox: "0 0 24 24",
                  "stroke-width": "1.3",
                  stroke: "currentColor",
                  class: "size-6 text-cyan-400"
                }, [
                  _createElementVNode("path", {
                    "stroke-linecap": "round",
                    "stroke-linejoin": "round",
                    d: "M12 21a9.004 9.004 0 0 0 8.716-6.747M12 21a9.004 9.004 0 0 1-8.716-6.747M12 21c2.485 0 4.5-4.03 4.5-9S14.485 3 12 3m0 18c-2.485 0-4.5-4.03-4.5-9S9.515 3 12 3m0 0a8.997 8.997 0 0 1 7.843 4.582M12 3a8.997 8.997 0 0 0-7.843 4.582m15.686 0A11.953 11.953 0 0 1 12 10.5c-2.998 0-5.74-1.1-7.843-2.918m15.686 0A8.959 8.959 0 0 1 21 12c0 .778-.099 1.533-.284 2.253m0 0A17.919 17.919 0 0 1 12 16.5c-3.162 0-6.133-.815-8.716-2.247m0 0A9.015 9.015 0 0 1 3 12c0-1.605.42-3.113 1.157-4.418"
                  })
                ]),
                _createElementVNode("h2", null, "11. Contact Information")
              ]),
              _createElementVNode("p", { class: "ms-4" }, " For legal inquiries, removal requests, or questions regarding these Terms, please contact: "),
              _createElementVNode("p", { class: "ms-4" }, [
                _createElementVNode("strong", null, "Lazuli Labs, Lda"),
                _createElementVNode("br"),
                _createElementVNode("a", {
                  href: "mailto:linksdigest@lazulilabs.com",
                  class: "text-white hover:text-cyan-400"
                }, "linksdigest@lazulilabs.com")
              ]),
              _createElementVNode("hr"),
              _createElementVNode("p", { class: "ms-4" }, " By using Links Digest, you acknowledge that you have read, understood, and agreed to these Terms & Conditions. "),
              _createElementVNode("a", {
                href: "/",
                class: "text-white/40 hover:text-white mt-5"
              }, "Back to Home")
            ])
          ])
        ])
      ])
    ], -1)
  ]))]))
}